import { render, staticRenderFns } from "./cocal-ranking-list.vue?vue&type=template&id=2e93814a&scoped=true&"
import script from "./cocal-ranking-list.vue?vue&type=script&lang=js&"
export * from "./cocal-ranking-list.vue?vue&type=script&lang=js&"
import style0 from "./cocal-ranking-list.vue?vue&type=style&index=0&id=2e93814a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e93814a",
  null
  
)

export default component.exports